"use client"

import { useEffect } from "react"
import "vanilla-cookieconsent/dist/cookieconsent.css"
import * as CookieConsent from "vanilla-cookieconsent"

export function CookieConsentBanner() {
  useEffect(() => {
    void CookieConsent.run({
      root: "#cc-container",
      autoShow: true,
      disablePageInteraction: false,
      hideFromBots: true,
      mode: "opt-in",
      revision: 1,

      cookie: {
        name: "cc_cookie",
        domain: location.hostname,
        path: "/",
        sameSite: "Lax",
        expiresAfterDays: 365,
      },

      guiOptions: {
        consentModal: {
          layout: "box inline",
          position: "bottom center",
          equalWeightButtons: false,
          flipButtons: false,
        },
        preferencesModal: {
          layout: "box",
          equalWeightButtons: true,
          flipButtons: false,
        },
      },

      categories: {
        necessary: {
          enabled: true,
          readOnly: true,
        },
        functionality: {
          enabled: false,
        },
        analytics: {
          enabled: false,
        },
      },

      language: {
        default: "en",
        translations: {
          en: {
            consentModal: {
              title: "We use cookies",
              description:
                "We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. By clicking 'Accept all', you consent to our use of cookies.",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Reject all",
              showPreferencesBtn: "Manage preferences",
              footer: `<a href="/cookies-policy">Cookie Policy</a>`,
            },
            preferencesModal: {
              title: "Cookie Preferences",
              acceptAllBtn: "Accept all",
              acceptNecessaryBtn: "Reject all",
              savePreferencesBtn: "Save preferences",
              closeIconLabel: "Close modal",
              serviceCounterLabel: "Service|Services",
              sections: [
                {
                  title: "Cookie Usage",
                  description:
                    "We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.",
                },
                {
                  title: 'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
                  description:
                    "These cookies are essential for the proper functioning of our website. They enable basic functions like page navigation and access to secure areas of the website.",
                  linkedCategory: "necessary",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Domain",
                      expiration: "Expiration",
                      description: "Description",
                    },
                    body: [
                      {
                        name: "__cf_bm",
                        domain: ".clerk.mycoachingspace.app",
                        expiration: "29 minutes",
                        description:
                          "Cloudflare places this cookie on end-user devices that access customer sites protected by Bot Management or Bot Fight Mode.",
                      },
                      {
                        name: "__clerk_*",
                        domain: ".mycoachingspace.app",
                        expiration: "Session / Persistent",
                        description:
                          "Authentication cookies used by Clerk for secure user authentication and session management.",
                      },
                    ],
                  },
                },
                {
                  title: "Performance and Functionality Cookies",
                  description:
                    "These cookies are used to enhance the performance and functionality of our website but are non-essential to their use. However, without these cookies, certain functionality may become unavailable.",
                  linkedCategory: "functionality",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Domain",
                      expiration: "Expiration",
                      description: "Description",
                    },
                    body: [
                      {
                        name: "_cfuvid",
                        domain: ".clerk.mycoachingspace.app",
                        expiration: "Session",
                        description:
                          "This cookie is set by Cloudflare to enhance security and performance. It helps identify trusted web traffic and ensures a secure browsing experience for users.",
                      },
                    ],
                  },
                },
                {
                  title: "Analytics and Customization Cookies",
                  description:
                    "These cookies collect information that is used either in aggregate form to help us understand how our website is being used or how effective our marketing campaigns are, or to help us customize our website for you.",
                  linkedCategory: "analytics",
                  cookieTable: {
                    headers: {
                      name: "Name",
                      domain: "Domain",
                      expiration: "Expiration",
                      description: "Description",
                    },
                    body: [
                      {
                        name: "s7",
                        domain: "mycoachingspace.app",
                        expiration: "Session",
                        description:
                          "Adobe Analytics cookie used to gather data regarding site usage and user behavior on the website.",
                      },
                    ],
                  },
                },
                {
                  title: "More information",
                  description:
                    'For more information about our cookie policy and practices, please visit our <a href="/cookies-policy">Cookie Policy</a> page or <a href="/privacy">Privacy Policy</a>.',
                },
              ],
            },
          },
        },
      },

      onChange: ({ cookie, changedCategories }) => {
        // Handle category changes
        if (changedCategories.includes("analytics")) {
          const analyticsAccepted = cookie.categories.includes("analytics")
          // Enable/disable analytics based on consent
          if (analyticsAccepted) {
            // Enable Adobe Analytics
            console.log("Analytics enabled")
          } else {
            // Disable Adobe Analytics
            console.log("Analytics disabled")
          }
        }
      },
    })
  }, [])

  return <div id="cc-container" />
}